import React, { useEffect, useState } from 'react';
import { Grid, Box, Pagination, Typography, IconButton, Select, MenuItem, Dialog, DialogContent } from '@mui/material';
// import DownloadIcon from '@mui/icons-material/Download';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as menuActions from '../store/actions/breadcrumb';
import { useLogout } from '../components/Utils';
import { useTranslation } from 'react-i18next';
import '../style/home.css';
import '../style/common.css';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import * as charityActions from '../store/actions/charitableActivity';
import appConfig from "../config/appConfig";
import { MultiSelect } from "react-multi-select-component";
import FormControl from '@mui/material/FormControl';
import { useForm } from 'react-hook-form';
import DatePicker from 'react-date-picker';
import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import moment from 'moment';
import * as Styled from '../components/styled-components/Styled-Components';
import '../style/common.css';
import FilterDropDown from '../components/DropDown';
import { useNavigate } from 'react-router-dom';
import Close  from '@mui/icons-material/Close';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import FilterListIcon from '@mui/icons-material/FilterList';



const dropDownlistCss = { mt: 1, mb: 1, borderRadius: "5px", border: `1px solid ${appConfig.colors.darkblue}`, background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px" } };
const datePropDownCss = { mt: 1, mb: 1, borderRadius: "5px", background: "#fcfcfb", width: "100%", '.MuiAutocomplete-input': { height: "5px", outline: "none" } };
const gridItemCss = { '&.MuiGrid-item': { pt: 0, pl: 2, pr: 2} };

const mb = { marginBottom: 0, fontWeight: "bold", color: appConfig.colors.darkgray };


const Gallery = ({
    setBreadcrumb,
    fetchGalleryDetails,
    galleryDetails,
    getBUnitFilterDetails, 
    bunitFilterList
}) => {
    const { t } = useTranslation('common');
    const onLogout = useLogout();
    const navigate = useNavigate();
    const sessionFilter = JSON.parse(window.sessionStorage.getItem("filterValuesGallery"));
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
      }, []);
    
    const [isFilterOpen, setIsFilterOpen] = useState(sessionFilter?.isFilterOpen || false);
    const [galleryInfo, setGalleryInfo] = useState([]);
    const [value, setValue] = React.useState('all');
    const [filterList, setFilterList] = useState([]);
    const [fromDate, setFromDate] = useState(sessionFilter?.startDate ? new Date(`${sessionFilter?.startDate}T00:00:00`) : null);
    const [toDate, setToDate] = useState(sessionFilter?.endDate ? new Date(`${sessionFilter?.endDate}T00:00:00`) : null);
    const [selected, setSelected] = useState(null);
    const [filterDropdown, setFilterDropdown] = useState(sessionFilter?.filterDropdown ||   'ALL')

    const [selectedBusinessUnits, setSelectedBusinessUnits] = useState([]);
    const [selectedLocationNames, setSelectedLocationNames] = useState([]);
    
    const [pagination, setPagination] = useState({ limit: sessionFilter?.pagination?.limit || 20, offset: sessionFilter?.pagination?.offset || 1 });

    const [page, setPage] = useState(pagination?.offset);
    const [rowsPerPage, setRowsPerPage] = useState(pagination?.limit);

    const [openPreview, setOpenPreview] = useState(false);
    const [previewSrc, setPreviewSrc] = useState('');
    const [isVideo, setIsVideo] = useState(false);

    const[filterValues, setFilterValues] = useState();
    useEffect(() => {
        const filterInitValues = {
            startDate: '',
            endDate: '',
            filterByBusinessUnit: setSelectedBusinessUnits([]),
            filterByBusinessUnitLocation: [],
            filterDropdown: "ALL",
            businessId :  businessUnitOptions?.map(item => item.value),
            location : selectedLocationNames?.map(item => item.value) || '',
        }
        setFilterValues(sessionFilter || filterInitValues)
        fetchGalleryDetails(sessionFilter || filterInitValues);
      },[])

    useEffect(() => {
        if (galleryDetails && galleryDetails && galleryDetails?.status === 200) {
          setGalleryInfo(galleryDetails?.data);
        } else if (galleryDetails && galleryDetails?.status === 401) {
          onLogout();
        }
    }, [galleryDetails]);

    useEffect(() => {
        setBreadcrumb(t('Gallery'));
    }, [setBreadcrumb, t]);
    useEffect(()=>{
        getBUnitFilterDetails();
    },[])
    useEffect(()=>{
    if(bunitFilterList && bunitFilterList?.status === 200){
    const dataArr = bunitFilterList?.data || []
    setFilterList(dataArr);
    const defaultFilter = dataArr?.map((businessUnit) => ({
        label: businessUnit?.businessUnitName,
        value: businessUnit?.businessUnitId,
    }));
    setSelectedBusinessUnits(sessionFilter?.filterByBusinessUnit || defaultFilter)
    setSelectedLocationNames(sessionFilter?.filterByBusinessUnitLocation || defaultFilterLoc)
    
    } else if(bunitFilterList && bunitFilterList?.status === 401){ 
        onLogout();
    }
    },[bunitFilterList, filterList])
    const businessUnitOptions = filterList?.map((businessUnit) => ({
        label: businessUnit.businessUnitName,
        value: businessUnit.businessUnitId,
    })).sort((a, b) => a?.label?.localeCompare(b.label));

    const defaultFilter = businessUnitOptions?.map(item => item.value);
    const handleBusinessUnitChange = (selectedOptions) => {
        setSelectedBusinessUnits(selectedOptions);
        // setSelectedLocationNames([]);
    };
    const getSelectedLocations = () => {
        return filterList.flatMap(item => item?.businessLocation?.map((location) => ({
          "locationId": location?.id,
          "locationName": location?.locationName
        })));
      };
    const updateLocationOptions = () => {
        const locations = getSelectedLocations();
        const locationOptions = [...new Set(locations)]?.map((item) => ({
            label: item?.locationName,
            value: item?.locationId,
        })).sort((a, b) => a?.label?.localeCompare(b.label));;
        const businessUnitOptions = filterList?.map((businessUnit) => ({
            label: businessUnit?.businessUnitName,
            value: businessUnit?.businessUnitId,
        }));
        return locationOptions;
        };
    const locationOptions = updateLocationOptions();
    const handleLocationChange = (selectedOptions) => {
        setSelectedLocationNames(selectedOptions);
    };
    const defaultFilterLoc = filterList
    ?.flatMap(item => item?.businessLocation?.filter(location => location) || [])
    ?.map(location => ({
        value: location?.id,
        label: location?.locationName,
    }));
    
    
    const handleToggle = () => {
        setIsFilterOpen(!isFilterOpen); // Toggle between true and false
    };
    
    const handlePreviewOpen = (src, isVideo) => {
        setPreviewSrc(src);
        setIsVideo(isVideo);
        setOpenPreview(true);
    };
    
    const handlePreviewClose = () => {
        setPreviewSrc('');
        setIsVideo(false);
        setOpenPreview(false);
    };

    const handleDummy = (e, nextPage) => {
        handlePagination(rowsPerPage, nextPage);
        setPage(nextPage);
    };

    const onLimitChange = (limit) => {
        setRowsPerPage(limit.value);
        handlePagination(limit.value, 1);
    };
    const handlePagination = (limit, offset) => {
        const data1 = JSON.parse(window.sessionStorage.getItem('filterValuesGallery'));
        if (data1 && data1.pagination) {
          data1.pagination.limit = limit; // Set your new limit value
          data1.pagination.offset = offset;
          window.sessionStorage.setItem('filterValuesGallery', JSON.stringify(data1));
        } else {
          const data2 = {
            pagination: {
                limit: limit,  // Default limit value
                offset: offset   // Default offset value
            }
          };
          window.sessionStorage.setItem('filterValuesGallery', JSON.stringify(data2));
        }
      
        setPagination({ limit, offset });
        setPage(filterValues?.pagination?.offset)
        filterValues.pagination = { limit, offset }
        fetchGalleryDetails(filterValues);
    }
    const downloadImage = (url) => {
        fetch(url,{cache: 'no-cache'})
        .then((response) => response.blob())
        .then((blob) => {
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "image.jpg";
        link.click();
        })
        .catch((error) => console.error("Error downloading the image:", error));
    };
    const handleChange = (newValue) => {
        setValue(newValue);
    };
    const handleFilterChange = (e) => {
        setFilterDropdown(e.target.value);
      };

    const getFileTypeFromUrl = (url) => {
        const splitArray = url?.split('.');
        const lastPart = splitArray[splitArray?.length - 1];
        const textBeforeQuestionMark = lastPart?.split('?')[0].toLowerCase();

        const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp',  'svg', 'jfif', 'tiff'];
        const videoExtensions = ['mp4', 'webm', 'ogg', 'mkv', 'avi', 'mov', 'flv'];

        if (imageExtensions.includes(textBeforeQuestionMark)) {
            return 'image';
        } else if (videoExtensions.includes(textBeforeQuestionMark)) {
            return 'video';
        } else {
            return 'unknown'; // or handle other types as needed
        }
    };
    const handleDownloadUrl = async(fileUrl) => {
        const downloadLink = document.createElement('a');
        downloadLink.href = fileUrl; // Assuming fileUrl is the direct HTTPS image URL
        downloadLink.download = 'downloaded_image.jpg';
      
        document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
      };
    const filterContent = () => {
        if (value === 'images') {
            return galleryInfo.filter(item => getFileTypeFromUrl(item.filePreSignedUrl) === 'image');
        }
        if (value === 'videos') {
            return galleryInfo.filter(item => getFileTypeFromUrl(item.filePreSignedUrl) === 'video');
        }
        return galleryInfo; // 'all' or any other default case
    };
    
    const { handleSubmit } = useForm();

    const onSubmit = () => {
        const filterValues2 = {
            filterByBusinessUnit: selectedBusinessUnits.length === businessUnitOptions.length ? [] : selectedBusinessUnits || businessUnitOptions?.map(item => item.value),
            filterByBusinessUnitLocation: selectedLocationNames.length === locationOptions.length ? [] : selectedLocationNames  || locationOptions?.map(item => item.value),
            startDate: fromDate ? moment(fromDate).format('YYYY-MM-DD') : null,
            endDate: toDate ? moment(toDate).format('YYYY-MM-DD') : null,
            filterDropdown: filterDropdown,
            businessId : selectedBusinessUnits?.map(item => item.value) || businessUnitOptions?.map(item => item.value),
            pagination: { limit: 20, offset: 1 },
            isFilterOpen: true
        }
        sessionStorage.setItem("filterValuesGallery", JSON.stringify(filterValues2))
        setFilterValues(filterValues2)
        fetchGalleryDetails(filterValues2);
        setPage(1)
        setRowsPerPage(20);
        setPagination({ limit: 20, offset: 1 })
    };

    const onClear = () => {
        const defaultFilterLoc = filterList
            ?.flatMap(item => item?.businessLocation?.filter(location => location) || [])
            ?.map(location => ({
            value: location?.id,
            label: location?.locationName,
            }));
        const filterInitValues = {
            startDate: '',
            endDate: '',
            filterByBusinessUnit: setSelectedBusinessUnits([]),
            filterByBusinessUnitLocation: [],
            filterDropdown: "ALL",
            businessId :  businessUnitOptions?.map(item => item.value),
            location : selectedLocationNames?.map(item => item.value) || '',
            }
        const defaultFilter = filterList?.map((businessUnit) => ({
            label: businessUnit?.businessUnitName,
            value: businessUnit?.businessUnitId,
        }));
        
        setSelectedBusinessUnits(defaultFilter);
        setSelectedLocationNames(defaultFilterLoc);
        setPagination({limit: 20, offset: 1});
        setPage(1);
        sessionStorage.removeItem("filterValuesGallery")
        setRowsPerPage(20);
        setFilterValues(filterInitValues);
        setFilterDropdown("ALL");
        setFromDate('');
        setToDate('');
        setSelected(null);
        fetchGalleryDetails(filterInitValues);
    }

    return (
        <div>
              <div className='filter-container'>
                <div onClick={handleToggle} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', float: 'right', marginBottom: 10, fontFamily: appConfig?.fontfamily }}>
                    <IconButton>
                    <FilterListIcon style={{ color: '#000' }}  />
                    </IconButton>
                    <b>{isFilterOpen ? t('hideFilters') : t('showFilters')}</b>
                </div>

            {isFilterOpen && (
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2} style={{alignItems: 'flex-end'}}>
                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("By Business Units")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={businessUnitOptions}
                                  value={selectedBusinessUnits || defaultFilter}
                                  onChange={handleBusinessUnitChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>
                        </Grid>

                        <Grid  item   xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>

                            <p style={mb}>{t("By Business Locations")}</p>
                            <FormControl sx={dropDownlistCss}>
                                <MultiSelect
                                  options={locationOptions}
                                  value={selectedLocationNames}
                                  onChange={handleLocationChange}
                                  labelledBy="Select"
                                  overrideStrings={{
                                    "allItemsAreSelected": t("All items are selected."),
                                    "noOptions": t("No options"),
                                    "search": t("Search"),
                                    "selectAll": t("Select All"),
                                    "selectSomeItems": t("Select...")
                                  }}
                                />
                            </FormControl>

                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>

                            <p style={mb}>{t("From Date")}</p>
                            
                            <FormControl sx={datePropDownCss} style={{height: 41}}>
                            <DatePicker
                                    // {...field}
                                    // sx={textboxCss}
                                    style={{marginBottom:0,  height: 40}}
                                    className='input-text-box1 mt-0' 
                                    onChange={(date) => setFromDate(date)} 
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                    value={fromDate}
                                />
                            </FormControl>
                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}>{t("To Date")}</p>
                            <FormControl sx={datePropDownCss}>
                            <DatePicker
                                    className='input-text-box1 mt-0' 
                                    onChange={(date) => setToDate(date)} 
                                    value={toDate}
                                    dayPlaceholder='DD'
                                    monthPlaceholder='MM'
                                    yearPlaceholder='YYYY'
                                />
                            </FormControl>
                        </Grid>
                        <Grid  item  xs={12} lg={3} md={3} xl={3} sx={gridItemCss}>
                            <p style={mb}></p>
                            <FormControl sx={datePropDownCss}>
                            <Select
                                value={filterDropdown}
                                onChange={handleFilterChange}
                                style={{ height: 38, fontSize: 14}}
                                className='filter-dropdown'
                                inputProps={{ 'aria-label': 'Without label' }}
                            >
                                <MenuItem className='filter-item' value={'ALL'}>{t("All")}</MenuItem>
                                <MenuItem className='filter-item' value={'image'}>{t("Images")}</MenuItem>
                                <MenuItem className='filter-item' value={'video'}>{t("Videos")}</MenuItem>
                            </Select>
                            </FormControl>
                        </Grid>
                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">
                                <Styled.PrimaryButton type="submit">
                                    {t("Apply")}
                                </Styled.PrimaryButton>

                            </FormControl>
                        </Grid>

                        <Grid
                            item
                            xs={12} lg={1} md={2} xl={1} sm={2}
                            style={{paddingLeft: "10px"}}
                        >
                            <FormControl sx={dropDownlistCss} className="filter-btn">

                                <Styled.CancelButton  sx={{padding:'5px'}} onClick={() => { onClear() }} >
                                    {t("Clear")} 
                                </Styled.CancelButton>
                            </FormControl>
                        </Grid>
                        

                    </Grid>
                </form>
            )}
            </div>
            <Grid container style={{marginTop: 60}}>
                <Grid item xs={12}>
                    <Box sx={{ width: '100%' }}>
                        {/* <Box  className="galleryBox">
                            <Button className={value === 'all' ? 'button-filled' : 'button-outline'}   onClick={() => handleChange('all')} sx={{ mx: 1 }}>
                                {t('All')}
                            </Button>
                            <Button className={value === 'images' ? 'button-filled' : 'button-outline'} onClick={() => handleChange('images')} sx={{ mx: 1 }}>
                                {t('Images')}
                            </Button>
                            <Button className={value === 'videos' ? 'button-filled' : 'button-outline'} onClick={() => handleChange('videos')} sx={{ mx: 1 }}>
                                {t('Videos')}
                            </Button>
                        </Box> */}
                        <Grid container spacing={2}>
                            {filterContent()?.map((item, index) => (
                                <Grid item xs={12} sm={6} md={3} key={index}>
                                    <Box className="galleryImgCard" 
                                        onClick={() => {
                                            navigate('/view-charitable-activity/'+item?.id);
                                        }}
                                        >
                                        {getFileTypeFromUrl(item.filePreSignedUrl) === 'image' ? (
                                            <img onClick={() => handlePreviewOpen(item.filePreSignedUrl, false)} src={item.filePreSignedUrl} alt={item.name} style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                                        ) : getFileTypeFromUrl(item.filePreSignedUrl) === 'video' ? (
                                            <video onClick={() => handlePreviewOpen(item.filePreSignedUrl, true)} src={item.filePreSignedUrl} controls style={{ width: '100%', height: '100%', objectFit: 'cover' }}/>
                                        ) : (
                                            <Box className="noPreview">
                                                <Typography variant="body2" color="text.secondary"> {t('No Preview Available')}</Typography>
                                            </Box>
                                        )}
                                        {getFileTypeFromUrl(item.filePreSignedUrl) === 'image' && (
                                            <>
                                            <Box className="hoverContent2">
                                                <IconButton onClick={(e) => { e.preventDefault(); e.stopPropagation(); downloadImage(item.filePreSignedUrl); } } sx={{ backgroundColor: 'white', boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' } }}>
                                                    <CloudDownloadIcon sx={{ color: '#005974' }} />
                                                </IconButton>
                                            </Box>
                                            <Box className="hoverContent">
                                                <IconButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); handlePreviewOpen(item.filePreSignedUrl, false) } } sx={{ backgroundColor: 'white', boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' } }}>
                                                    <RemoveRedEyeIcon sx={{ color: '#005974' }} />
                                                </IconButton>
                                            </Box>
                                            </>
                                        )}
                                        {getFileTypeFromUrl(item.filePreSignedUrl) === 'video' && (
                                            <Box className="hoverContent">
                                                <IconButton onClick={(e) => {e.preventDefault(); e.stopPropagation(); handlePreviewOpen(item.filePreSignedUrl, true) } } sx={{ backgroundColor: 'white', boxShadow: '0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12)', '&:hover': { backgroundColor: 'rgba(255, 255, 255, 0.8)' } }}>
                                                    <RemoveRedEyeIcon sx={{ color: '#005974' }} />
                                                </IconButton>
                                            </Box>
                                        )}
                                        <Box className={getFileTypeFromUrl(item.filePreSignedUrl) === 'video' ? "imgBox1" : "imgBox"}>
                                            <Typography variant="body" color="#000">
                                                <b>{item.charityName}</b>
                                            </Typography>
                                            <Typography variant="h5" component="h2" style={{marginBottom: 20, fontSize: 20, textDecoration: 'underline', fontWeight: 'bold'}} color="#000">
                                                {item.eventName}
                                            </Typography>
                                            <div className='gradientDivider'></div>
                                        </Box>
                                    </Box>
                                </Grid>
                            ))}
                            <Grid item xs={12} sm={12} xl={12} lg={12} md={12}>
                                {filterContent()?.length !== 0 && pagination?.limit && (
                                    <div style={{ justifyContent: "right", display: "flex" }}>
                                        <div style={{ marginRight: "10px" }}>
                                        <FilterDropDown isEnableFirstItem={false} selectedValue={{ key: pagination?.limit, value: pagination?.limit }} selectOptions={[{ key: pagination?.limit, value: pagination?.limit }, { key: '20', value: '20' }, { key: '80', value: '80' }, { key: '120', value: '120' }]} onSelect={onLimitChange} />
                                        </div>
                                        <Pagination page={page} onChange={handleDummy} count={Math.ceil((galleryDetails?.totalCount) / rowsPerPage)} 
                                        sx={{
                                        "& .MuiPaginationItem-root": {
                                            color: appConfig.colors.darkblue,
                                        }
                                        
                                        }}
                                        
                                        variant="outlined" shape="rounded" />
                                    </div>
                                )}
                                {galleryDetails && galleryDetails?.data && filterContent()?.length === 0 && (
                                    <div style={{ color: appConfig.colors.darkgray, textAlign: "center", marginTop: "8%" }}> <FormatListBulletedIcon sx={{ fontSize: 80, fontFamily: appConfig.fontfamily }} /><h2 style={{ fontSize: appConfig.font16 }}>No Data</h2></div>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
            <Dialog open={openPreview} onClose={handlePreviewClose} maxWidth="md" fullWidth>
                <DialogContent>
                <Typography className="mb-20 mt-10 md-bold">
                {t("Preview")}
                </Typography>
                <IconButton
                    edge="end"
                    color="inherit"
                    onClick={handlePreviewClose}
                    aria-label="close"
                    sx={{ position: 'absolute', top: 30, right: 30 }}
                >
                    <Close />
                </IconButton>
                {isVideo ? (
                    <video src={previewSrc} style={{ width: '100%' }} controls />
                ) : (
                    <img src={previewSrc} alt="Preview Image" style={{ width: '100%' }} />
                )}
                </DialogContent>
            </Dialog>

        </div>
    );
};

const mapStateToProps = (state) => ({ 
  galleryDetails: state.charitableActivity.galleryDetails,
  bunitFilterList: state.charitableActivity.bunitFilterList,
});

const mapDispatchToProps = (dispatch) => {
  return {
    fetchGalleryDetails: (filterValues) => dispatch(charityActions.fetchGalleryDetails(filterValues)),
    setBreadcrumb: (menu) => dispatch(menuActions.changeMenu(menu)),
    getBUnitFilterDetails: () => dispatch(charityActions.getBUnitFilterDetails()),
  };
};

Gallery.propTypes = {
  fetchGalleryDetails: PropTypes.func.isRequired,
  setBreadcrumb: PropTypes.func.isRequired,
  getBUnitFilterDetails: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Gallery);
